let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bzRG7")).then(() => parcelRequire('dFPRW'));